import { render } from "./SearchResultsPreview.vue?vue&type=template&id=1a2b7942"
import script from "./SearchResultsPreview.vue?vue&type=script&lang=js"
export * from "./SearchResultsPreview.vue?vue&type=script&lang=js"

import "./SearchResultsPreview.vue?vue&type=style&index=0&id=1a2b7942&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__